module.exports = "<section class=\"main\">\r\n\t<section class=\"main-content\" ui-view=\"main\"><section>\r\n</section>\r\n";
